import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import InfoIcon from '@mui/icons-material/Info'
import { Box, Grid, Menu, MenuItem, styled } from '@mui/material'
import ApprovalApi, { ApprovalStatus } from 'api/approval/approval.api'
import { BranchInterface } from 'api/master/clinic.api'
import PersonnelApi from 'api/setting/personnel-managements/personnel.api'
import { selectMe } from 'app/slice/user.slice'
import IconStopCircle from 'assets/icon/IconStopCircle'
import IconApplival from 'assets/icon/iconApplival'
import IconCancel from 'assets/icon/iconCancel'
import IconCancelCircle from 'assets/icon/iconCancelCircle'
import IconInfo from 'assets/icon/iconInfo'
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputSecondNewRangePicker from 'component/Input/InputSecondNewRangePicker'
import Loading from 'component/Loading'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import PopupFinanceAcknowledge from 'component/Treatments/PopupFinanceAcknowledge'
import { colors } from 'constants/theme'
import { ListFilterDoctors } from 'features/counter/appointment/head-appointment'
import _ from 'lodash'
import moment from 'moment'
import MainButton from 'new-components/buttons/main-button'
import TextInput from 'new-components/inputs/text-input'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { routeName } from 'routes/routes-name'
import { toBuddhistYear } from 'utils/app.utils'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

const permissions = {
    isCreate: isCreate(),
    isDelete: isDelete(),
    isUpdate: isUpdate(),
    isView: isView()
}

const ApprovelList = () => {
    const { t } = useTranslation()
    const history = useHistory()
    const [load, setLoad] = useState<boolean>(false)
    const user = useSelector(selectMe)

    const [dataApprovellist, setDataApprovellist] = useState<any>([])
    const styleSelector = { textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }

    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [rowCount, setRowCount] = useState(0)
    const [sortBy, setSortBy] = useState('approvalItemId')
    const [sortType, setSortType] = useState('DESC')
    const [search, setSearch] = useState('')

    const [funcLinkOptions, setFuncLinkOptions] = useState<any>([
        {
            key: "hasCancelReciept",
            funcLinkName: 'ยกเลิกใบเสร็จ',
            value: 'CANCEL_RECEIPT'
        },
        {
            key: "hasChangeCost",
            funcLinkName: 'จัดการค่ารักษา',
            value: 'CHANGE_COST'
        },
        {
            key: "hasChangeOverduePaymeny",
            funcLinkName: 'ใบขอค้างชำระ',
            value: 'OVERDUE_PAYMENT'
        }
    ])
    const [funcLinkSelect, setFuncLinkSelect] = useState<any>({})
    const [rangeDate, setRangeDate] = useState<string[]>(['', ''])
    const [branches, setBranches] = useState<BranchInterface[]>([])
    const [branchSelect, setBranchSelect] = useState<any>(null)
    const [applicant, setApplicant] = useState([
        { label: t('APPROVELLIST.FILTER.APPROVED'), value: 'APPROVED' },
        { label: t('APPROVELLIST.FILTER.PENDING'), value: 'PENDING' },
        { label: t('APPROVELLIST.FILTER.REJECT'), value: 'REJECT' },
        { label: t('APPROVELLIST.FILTER.CANCEL'), value: 'CANCEL' },
        // { label: 'รอการเงินรับทราบ', value: 'WAITING_FINANCE' }
    ])
    const [financeAckPopup, setFinanceAckPopup] = useState<{ open: boolean, data: any }>({ open: false, data: null })
    const [applicantSelect, setApplicantSelect] = useState<any>({})
    const [userOption, setUserOption] = useState<any>([])
    const [userSelect, setUserSelect] = useState<any>({})

    const loadFilterOption = async () => {
        await ApprovalApi.findApprovalBranch().then(({ data }) => data && setBranches(data))
    }

    const loadFilterUser = async (search?: string) => {
        const condition = {
            page: 1,
            pageLimit: 30,
            search: search,
            sortBy: sortBy,
            sortType: sortType,
        }
        await PersonnelApi.findAll(condition).then((res) => {
            setUserOption(res?.data || [])
        })
    }

    useEffect(() => {
        loadFilterOption()
        loadFilterUser()
    }, [])

    const loadApprovalList = async () => {
        setLoad(true)
        const checkDate = ((rangeDate[0] !== 'Invalid date' && rangeDate[0]) && (rangeDate[1] !== 'Invalid date' && rangeDate[1]))
        const condition = {
            page: page,
            pageLimit: pageLimit,
            search: search,
            sortBy: sortBy,
            sortType: sortType,
            branchId: branchSelect,
            STATUS: applicantSelect?.value || '',
            USER: userSelect?.userId || '',
            dateStart: checkDate ? rangeDate[0] : '',
            dateEnd: checkDate ? rangeDate[1] : '',
            approveType: funcLinkSelect?.value || '',
            userId: user?.userId || 0
        }

        await ApprovalApi.findApprovalListAll(condition).then((res) => {
            setRowCount(res?.headers['x-total'] || 0)
            setDataApprovellist(res?.data || [])
        }).finally(() => {
            setLoad(false)
        })
    }

    useEffect(() => {
        if (user?.userId) {
            loadApprovalList()
        }
    }, [page, pageLimit, sortBy, sortType, user?.userId])

    const onView = (objData: any) => {
        if (objData?.approveType === 'CANCEL_RECEIPT') {
            history.push(routeName.approvelListCancelReciept,
                {
                    orderPaymentId: objData?.refId,
                    approval: true,
                    approvalItemId: objData?.approvalItemId,
                })
        } else if (objData?.approveType === 'CHANGE_COST') {
            history.push(routeName.approvelListCost,
                {
                    approval: true,
                    objData: objData,
                })
        } else {
            history.push(routeName.approvelListOutstandingPayment,
                {
                    approval: true,
                    objData: objData,
                })
        }
    }

    const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
        setSortType(sortTypeVal)
        setSortBy(sortByVal)
    }

    const handleChangePage = (val: number) => setPage(val)

    const handleChangeRowsPerPage = (limit: number) => setPageLimit(limit)

    const headCells = [
        { id: 'no', disablePadding: false, label: '#', width: '50px', align: 'center', },
        { id: 'branchlName', disablePadding: false, label: t('APPROVELLIST.TABLE.BRANCH'), align: 'center', sortable: true },
        { id: 'date', disablePadding: false, label: t('APPROVELLIST.TABLE.DATE'), align: 'center', sortable: true },
        { id: 'menuFunc', disablePadding: false, label: t('APPROVELLIST.TABLE.MENUFUNC'), align: 'center', },
        { id: 'updatedBy', disablePadding: false, label: t('APPROVELLIST.TABLE.APPLICANT'), width: '180px' },
        { id: 'approvedBy', disablePadding: false, label: t('APPROVELLIST.TABLE.APPROVEDBY'), width: '180px' },
        { id: 'status', disablePadding: false, label: t('APPLICATION.TABLE.CELL.STATUS'), width: '150px' },
        { id: 'action', disablePadding: false, label: 'Action', width: '80px' }
    ]

    const renderData = (objData: any, index: number) => {
        index = page * pageLimit - pageLimit + index + 1
        const { approvalItemId, createdAt, status, branchId, approveType, requestUserName, approvedBy, approvedAt, refType } = objData
        let color = '';
        // let statusLabel = status;
        switch (status) {
            case "APPROVED":
                color = colors.statusActive;
                break;
            case "REJECT":
                color = colors.statusInactive;
                break;
            case "CANCEL":
                color = colors.gray;
                break;
            // case "WAITING_FINANCE":
            //     color = '#FF9800';
            //     statusLabel = 'รอการเงินรับทราบ';
            //     break;
            default:
                color = '#EDBA07';
        }

        const objRenderData = {
            key: approvalItemId,
            id: approvalItemId,
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: index },
                { option: 'TEXT', align: 'center', label: branches?.find((item) => item?.branchId === branchId)?.branchName || '' },
                { option: 'TEXT', align: 'center', label: `${toBuddhistYear(moment(createdAt), 'DD/MM/YYYY HH:mm')} ${t('APPOINTMENT.TIME')}` || '' },
                { option: 'TEXT', align: 'center', label: `${t(`APPROVELLIST.TYPE.${approveType}`)} ${refType === "RETROSPECTIVE_TREATMENT" ? `(รายการย้อนหลัง)` : ""}` || '' },
                { option: 'UPDATE_BY', align: 'center', label: { updatedBy: requestUserName || '-', updatedAt: createdAt ?? '10/12/2564 08.59' } },
                { option: 'UPDATE_BY', align: 'center', label: { updatedBy: approvedBy || '-', updatedAt: approvedAt || '-' } },
                {
                    option: 'COMPONENT', align: 'center',
                    component: (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', width: 170 }}>
                            <FontAwesomeIcon icon={faCircle} color={color} />
                            {/* <span className="ml-2">{status === 'WAITING_FINANCE' ? statusLabel : t(`APPROVELLIST.FILTER.${status}`)}</span> */}
                            <span className="ml-2">{t(`APPROVELLIST.FILTER.${status}`)}</span>
                        </Box>

                    )
                },
                {
                    option: 'ACTION',
                    align: 'center',
                    label: 'action',
                    // values: status === 'WAITING_FINANCE'
                    //     ? [{ option: 'CUSTOM', label: 'รับทราบ', disabled: false }]
                    //     : [{ option: 'VIEW', label: t(`APPROVELLIST.TABLE.VIEW`), disabled: permissions.isView.disabled }]
                    values: [{ option: 'VIEW', label: t(`APPROVELLIST.TABLE.VIEW`), disabled: permissions.isView.disabled }]
                },
            ]
        }

        return (
            <TableRowCommon
                {...objRenderData}
                onView={() => {
                    // if (status === 'WAITING_FINANCE') {
                    //     setFinanceAckPopup({ open: true, data: objData })
                    // } else {
                    //     onView(objData)
                    // }
                    onView(objData)
                }}
            />
        )
    }

    return (
        <Box>
            <Loading show={load} />
            <Box sx={{ display: 'flex', flexDirection: 'column', backgroundColor: '#fff', borderRadius: '0.25rem', height: '100%' }}>
                <HeaderCard text={t('APPROVELLIST.TITLE')} />
                <Box sx={{ flex: '1 1 auto', p: '16px' }}>
                    <Box sx={{ mb: 0 }}>
                        <Grid container columns={16}>
                            <Grid item xs={16} md={4} lg={3} xl={3} className="px-1 mb-2 w-100">
                                <TextInput onChange={(e) => setSearch(e.target.value)} value={search} fullWidth label={t('APPROVELLIST.SEARCH')} />
                            </Grid>
                            <Grid item xs={16} md={4} lg={3} xl={3} className="px-1 mb-2 w-100">
                                <Box sx={{ '.MuiInputBase-root': { paddingRight: '25px !important' } }}>
                                    <AutocompleteSelect
                                        labelId="branch"
                                        options={["ALL", ...branches]}
                                        getOptionLabel={(option) => `${t('APPROVELLIST.FILTER.BRANCH')}:${option?.branchName || t('ALL')}`}
                                        renderOption={(props, option) => {
                                            return (
                                                <ListFilterDoctors {...props} key={option.branchId} component="li" sx={styleSelector}>
                                                    {option === "ALL" ? t('ALL') : option.branchName}
                                                </ListFilterDoctors>
                                            )
                                        }}
                                        onchange={(e, value) => setBranchSelect(value?.branchId)}
                                        noOptionsText={t('NOT_FOUND')}
                                        value={_.find(branches, { branchId: branchSelect }) || ''}
                                        height={40}
                                        disableClearable={!branchSelect}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={16} md={4} lg={3} xl={3} className="px-1 mb-2 w-100">
                                <Box sx={{ '.MuiInputBase-root': { paddingRight: '25px !important' } }}>
                                    <AutocompleteSelect
                                        labelId="status"
                                        options={["ALL", ...applicant]}
                                        getOptionLabel={(option) => `${t('APPROVELLIST.FILTER.STATUS')}:${option.label || t('ALL')}`}
                                        renderOption={(props, option) => {
                                            return (
                                                <ListFilterDoctors {...props} component="li" sx={styleSelector}>
                                                    {option === "ALL" ? t('ALL') : option.label}
                                                </ListFilterDoctors>
                                            )
                                        }}
                                        onchange={(e, value) => setApplicantSelect(value)}
                                        noOptionsText={t('NOT_FOUND')}
                                        value={_.find(applicant, { value: applicantSelect?.value }) || ''}
                                        height={40}
                                        disableClearable={!applicantSelect}

                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={16} md={4} lg={3} xl={3} className="px-1 mb-2 w-100">
                                <Box sx={{ '.MuiInputBase-root': { paddingRight: '25px !important' } }}>
                                    <AutocompleteSelect
                                        labelId="user"
                                        options={["ALL", ...userOption]}
                                        getOptionLabel={(option) => `${t('APPROVELLIST.FILTER.APPLICANT')}:${option?.firstname ? option.firstname + " " + option.lastname : t('ALL')}`}
                                        renderOption={(props, option) => {
                                            return (
                                                <ListFilterDoctors {...props} key={option.userId} component="li" sx={styleSelector}>
                                                    {option === "ALL" ? t('ALL') : `${option.firstname} ${option.lastname}`}
                                                </ListFilterDoctors>
                                            )
                                        }}
                                        onchange={(e, value) => setUserSelect(value)}
                                        noOptionsText={t('NOT_FOUND')}
                                        value={_.find(userOption, { userId: userSelect?.userId }) || ''}
                                        height={40}
                                        disableClearable={!userSelect?.userId}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={16} md={4} lg={3} xl={3} className="px-1 mb-2 w-100">
                                <InputSecondNewRangePicker value={rangeDate} inputHeight={40} onchange={(val: any) => {
                                    setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                                }} />
                            </Grid>
                            <Grid item xs={12} md={6} lg={1} xl={1} className="px-1 mb-2 w-100">
                                <MainButton
                                    title={t('INPUT.SEARCH')}
                                    type='primary'
                                    variant='contained'
                                    style={{ width: '120px' }}
                                    onClick={() => {
                                        loadApprovalList()
                                        setPage(1)
                                    }} />
                            </Grid>
                        </Grid>
                    </Box>

                    <Box className={'mt-3 pl-xl-3 pr-xl-2'}>
                        <TableCustom
                            page={page}
                            pageLimit={pageLimit}
                            sortType={sortType}
                            sortBy={sortBy}
                            onSort={onRequestSort}
                            setPageLimit={handleChangeRowsPerPage}
                            setPage={handleChangePage}
                            rowCount={rowCount}
                            headCells={headCells}
                            rowsData={dataApprovellist?.length && dataApprovellist?.map((item: any, index: number) => {
                                return renderData(item, index)
                            }) || []}
                        />
                    </Box>
                </Box>
            </Box>

            {/* Popup สำหรับพนักงานการเงินเซ็นรับทราบ */}
            <PopupFinanceAcknowledge
                open={financeAckPopup.open}
                data={financeAckPopup.data}
                onClose={() => setFinanceAckPopup({ open: false, data: null })}
                onSuccess={() => loadApprovalList()}
                financeUserName={user?.fullname || ''}
            />
        </Box >
    )
}

export default ApprovelList

export const DropdownToggleApproval = styled(Box, { shouldForwardProp: (prop) => prop !== 'bg' && prop !== 'isdisabled' })<{ bg: string, isdisabled: '0' | '1' }>(({ theme, bg, isdisabled }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    borderRadius: '50px',
    padding: '6px 16px',
    border: '1px solid transparent',
    backgroundColor: bg || '#FFF3E5',
    cursor: isdisabled === '1' ? 'default' : 'pointer',
    pointerEvents: isdisabled === '1' ? 'none' : 'auto',
    ":after": {
        content: '""',
        display: isdisabled === '1' ? 'none' : 'block',
        marginLeft: '0.255em',
        verticalAlign: '0.255em',
        borderTop: '0.3em solid',
        borderRight: '0.3em solid transparent',
        borderBottom: 0,
        borderLeft: '0.3em solid transparent'
    }
}))

const DropdownMenu = styled(Menu)(({ theme }) => ({}))
const DropdownItem = styled(MenuItem)(({ theme }) => ({
    color: colors.textPrimary,
    '&:hover': {
        backgroundColor: colors.themeSecondColor06,
        color: colors.themeSecondColor
    }
}))

const ApprovalSelectorCustoms = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    '.user-approvel': {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '12px',
        'path': {
            fill: '#A8A8A8'
        },
        '.user-fullname': {
            color: '#808080'
        }
    }
}))


type ApprovalSelectorCustomProps = {
    approval: ApprovalStatus | 'WAITING_FINANCE'
    onChange?: (data: any) => void
    disabled?: boolean
    userApprovel?: { fullname: string, date: string, remark?: string }
    onClick?: (value: boolean) => void
    showClose?: boolean
    hideWaitingFinance?: boolean
}

export const approvalStatusList = {
    'APPROVED':
    {
        bg: '#D1F1EB',
        label: ApprovalStatus.APPROVED,
        disabled: true,
        icon: <IconApplival />,
    },
    'PENDING': {
        bg: '#FFF3E5',
        label: ApprovalStatus.PENDING,
        disabled: false,
        icon: <IconInfo />,
    },
    'REJECT': {
        bg: '#FFF0F2',
        label: ApprovalStatus.REJECT,
        disabled: true,
        icon: <IconCancel />,
    },
    'CANCEL': {
        bg: '#BBBBBB',
        label: ApprovalStatus.CANCEL,
        disabled: true,
        icon: <IconStopCircle />,
    },
    'WAITING_FINANCE': {
        bg: '#FFE0B2',
        label: "WAITING_FINANCE",
        disabled: false,
        icon: <IconInfo />,
    }
}



export const ApprovalSelectorCustom = (props: ApprovalSelectorCustomProps) => {
    const { t } = useTranslation()
    const location = useLocation()
    const { showClose = true } = props
    const isRequestOverduePage = location?.pathname?.includes('/approvel-list/request-overdue') || location?.pathname?.includes('/approvel-list/cancel-reciept') || location?.pathname?.includes('/approvel-list/change-cost')
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)
    const handleClose = () => setAnchorEl(null)

    return (
        <ApprovalSelectorCustoms className={`box-approvel-selector`} >
            {(props?.userApprovel && props?.userApprovel?.fullname) && (
                <Box className={`user-approvel`}>
                    <InfoIcon />
                    <span>
                        {t(`APPROVELLIST.FILTER.${approvalStatusList[props.approval]?.label}`)}
                    </span>
                    <span className={`user-fullname`}>
                        {t('APPROVELLIST.APPROVAL.USERAPPROVAL', {
                            userApprovel: props?.userApprovel?.fullname,
                            date: `${toBuddhistYear(moment(props?.userApprovel?.date), "DD/MM/YYYY HH:mm")} ${t('TIME_UNIT')}`
                        })}
                    </span>
                </Box>
            )}
            <Box className={`approvel-selector`}>
                <Box>
                    <DropdownToggleApproval
                        className="btn-table-action text-black-50 shadow-none"
                        bg={`${approvalStatusList[props.approval]?.bg} !important`}
                        isdisabled={props?.disabled ? '1' : '0'}
                        onClick={(e: any) => { if (!props.disabled) setAnchorEl(e.currentTarget as HTMLElement) }}
                        sx={{
                            pointerEvents: props.disabled ? "none" : "auto",
                            position: "relative",
                        }}
                    >
                        <Box>{approvalStatusList[props.approval]?.icon}</Box>
                        <Box sx={{ color: 'black' }}>{t(`APPROVELLIST.FILTER.${approvalStatusList[props.approval]?.label}`)}</Box>
                        {((props.approval === ApprovalStatus.PENDING || props.approval === 'WAITING_FINANCE') && props?.disabled) &&
                            <Box onClick={(e) => {
                                e.stopPropagation();
                                props.onClick?.(true);
                            }} sx={{
                                pointerEvents: "auto",
                                marginLeft: "8px",
                            }}>
                                {showClose && <IconCancelCircle width='13' height='13' fill={`${colors.gray}`} />}
                            </Box>}
                    </DropdownToggleApproval>
                    <DropdownMenu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                    >
                        {Object.entries(approvalStatusList).map(([key, { bg, label, disabled, icon, }]) => {
                            if (key !== 'CANCEL' && key !== 'NORMAL') {
                                // ซ่อน WAITING_FINANCE ในหน้า /approvel-list/request-overdue และหน้า adjustment (ส่ง hideWaitingFinance) — เคส MN-2605-0194
                                if (key === 'WAITING_FINANCE' && (isRequestOverduePage || props.hideWaitingFinance)) {
                                    return null
                                }
                                return (
                                    <DropdownItem
                                        key={key}
                                        onClick={() => { props?.onChange && props.onChange(label); handleClose() }}
                                        disabled={key === ApprovalStatus.PENDING && props.approval === ApprovalStatus.PENDING}
                                    >
                                        {t(`APPROVELLIST.FILTER.${label}`)}
                                    </DropdownItem>
                                )
                            }
                        })}
                    </DropdownMenu>
                </Box>
            </Box>
        </ApprovalSelectorCustoms >
    )
}